export default "__VITE_ASSET__C1K$scOj__"